/* eslint-disable no-param-reassign */
import { createAsyncThunk } from '@reduxjs/toolkit';

import picsioConfig from '../../../../../config';
import { showDialog } from '../../components/dialog';
import l18n from '../../shared/strings';
import updateUser from '../actions/user/updateUser';
import Toast from '../../components/Toast';

const showInboxRequestFullAccessDialog = (inboxesLimit, Logger) => {
  showDialog({
    title: l18n.INBOXESTREE.requestFullDialog.title,
    text: l18n.INBOXESTREE.requestFullDialog.text(inboxesLimit),
    textBtnOk: l18n.INBOXESTREE.requestFullDialog.ok,
    textBtnCancel: l18n.INBOXESTREE.requestFullDialog.cancel,
    onOk: async () => {
      Logger.log('User', 'InboxRequestFullAccessModalChatClicked');
      await window.Intercom('showNewMessage');
      setTimeout(() => {
        window.Intercom('private:sendMessage',
          'Hi, I’d like to get full access to the Inboxes feature in Toriut.com. What’s the process to activate it?');
      }, 2000);
    },
    onCancel: () => Logger.log('User', 'InboxRequestFullAccessModalClosed'),
  });
  Logger.log('User', 'InboxRequestFullAccessModalShown', {
    initiation_location: 'Create inbox API error',
  });
};

export const create = createAsyncThunk(
  'inboxes/create',
  async ({ name, force = false }, {
    extra: {
      sdk, utils, Logger, showErrorDialog,
    },
    getState,
    dispatch,
  }) => {
    try {
      const { data } = await sdk.inboxes.create(name, force);
      const { subscriptionFeatures, addonsFeatures = {}, _id } = getState().user;
      Logger.log('UI', '_inbox_inbox_created', { inbox_name: data.name, created_by: _id });
      const copyAddonsFeatures = { ...addonsFeatures };
      const copySubscriptionFeatures = { ...subscriptionFeatures };
      if (force) {
        copyAddonsFeatures.inboxesLimit = addonsFeatures?.inboxesLimit ? copyAddonsFeatures.inboxesLimit + 1 : 1;
        copySubscriptionFeatures.inboxesLimit += 1;
        Toast(l18n.TOAST.UPGRADE_ADDON_SUCCESS('1 inbox'));
      }
      dispatch(updateUser({
        addonsFeatures: {
          ...copyAddonsFeatures,
        },
        subscriptionFeatures: {
          ...copySubscriptionFeatures,
          inboxesCount: subscriptionFeatures.inboxesCount + 1,
        },
      }));
      return data;
    } catch (error) {
      const errorMessage = utils.getDataFromResponceError(error, 'msg') || 'Can not create inbox';
      const errorSubcode = utils.getDataFromResponceError(error, 'subcode');
      const { subscriptionFeatures } = getState().user;

      if (errorSubcode === 'PlanLimitError' && picsioConfig.isPim) {
        showInboxRequestFullAccessDialog(subscriptionFeatures.inboxesLimit, Logger);
      } else {
        showErrorDialog(errorMessage);
      }
      Logger.error(new Error('Error inbox creating'), { error }, [
        'CreateInboxFailed',
        { errorMessage: errorMessage || 'NoMessage' },
      ]);
      throw error;
    }
  },
);

export const reducer = (builder) => {
  builder
    .addCase(
      create.pending,
      (state, { meta }) => {
        state.nameCreatingInbox = meta.arg.name;
        state.isCreatingInbox = true;
      },
    )
    .addCase(
      create.fulfilled,
      (state, { payload }) => {
        Object.keys(payload.fields).forEach((key) => {
          /** Set titles to default fields */
          if (!Array.isArray(payload.fields[key])) {
            payload.fields[key].title = l18n.INBOXSETTINGS.DEFAULT_FIELDS[key];
          }
        });
        state.inboxes.push(payload);
        state.nameCreatingInbox = null;
        state.error = null;
        state.isCreatingInbox = false;
      },
    )
    .addCase(
      create.rejected,
      (state, { error }) => {
        state.nameCreatingInbox = null;
        state.error = error;
        state.isCreatingInbox = false;
      },
    );
};
